import React, { Component } from 'react';
import { withRouter } from 'react-router';
import Inputnormal from './Inputnormal';
import { firebaseRef } from '../firebase.js';

class Tried extends Component {
  constructor(props){
    super(props);
    this.state = {
        checkingPrime: '',
        checkingKey: '',
        checkingDrain: '',
    };
    this.checkingPrime=this.checkingPrime.bind(this);
    this.checkingKey=this.checkingKey.bind(this);
    this.checkingDrain=this.checkingDrain.bind(this);
    this.componentWillMount=this.componentWillMount.bind(this);
  }

  componentWillMount(){
    var that=this;
    //this.setState({ loader: true });
    var userId = this.props.match.params.user;
    var doctor = this.props.match.params.doctor;
    var refMainPrime = firebaseRef.database().ref('doctors/'+doctor+'/users/'+userId+'/prime');
    var refMainKey = firebaseRef.database().ref('doctors/'+doctor+'/users/'+userId+'/key');
    var refMainDrain = firebaseRef.database().ref('doctors/'+doctor+'/users/'+userId+'/drain');
    refMainPrime.on('child_added', (datasnapShot) => {
      var value = datasnapShot.val();
        that.setState({ checkingPrime: value });
});
    refMainKey.on('child_added', (datasnapShot) => {
      var value = datasnapShot.val();
    that.setState({ checkingKey: value });
});
    refMainDrain.on('child_added', (datasnapShot) => {
      var value = datasnapShot.val();
    that.setState({ checkingDrain: value });
});
  }

checkingPrime(event){
  var that=this;
  var user = this.props.match.params.user;
  var doctor = firebaseRef.auth().currentUser.uid;
  var refMain = firebaseRef.database().ref('doctors/'+doctor+'/users/'+user+'/prime');
  refMain.update({
    prime: event.target.value
  });
  that.setState({ checkingPrime: event.target.value });
}

checkingKey(event){
  var that=this;
  var user = this.props.match.params.user;
  var doctor = firebaseRef.auth().currentUser.uid;
  var refMain = firebaseRef.database().ref('doctors/'+doctor+'/users/'+user+'/key');
  refMain.update({
    key: event.target.value
  });
  that.setState({ checkingKey: event.target.value });
}

checkingDrain(event){

  var that=this;
  var user = this.props.match.params.user;
  var doctor = firebaseRef.auth().currentUser.uid;
  var refMain = firebaseRef.database().ref('doctors/'+doctor+'/users/'+user+'/drain');
  refMain.update({
    drain: event.target.value
  });
  that.setState({ checkingDrain: event.target.value });
}

  render() {
    return (
      <div id="tried">
        <form className="grid-forms">
          <div className="flex-divs flex-divs-style"><h3>Tried of Change</h3></div>
          <div className="flex-divs">
            <div className="inner-grid-divs">
              <div className="flex-divs"><p>Prime</p></div>
              <div className="flex-inner-divs">
                <Inputnormal title="S" group="S-Prime" click={this.checkingPrime} checking={this.state.checkingPrime}/>
                <Inputnormal title="B" group="B-Prime" click={this.checkingPrime} checking={this.state.checkingPrime}/>
                <Inputnormal title="P" group="P-Prime" click={this.checkingPrime} checking={this.state.checkingPrime}/>
              </div>
            </div>
            <div className="inner-grid-divs">
              <div className="flex-divs"><p>Key</p></div>
              <div className="flex-inner-divs">
                <Inputnormal title="S" group="S-Key" click={this.checkingKey} checking={this.state.checkingKey}/>
                <Inputnormal title="B" group="B-Key" click={this.checkingKey} checking={this.state.checkingKey}/>
                <Inputnormal title="P" group="P-Key" click={this.checkingKey} checking={this.state.checkingKey}/>
              </div>
            </div>
            <div className="inner-grid-divs">
              <div className="flex-divs"><p>Drain</p></div>
              <div className="flex-inner-divs">
                <Inputnormal title="S" group="S-Drain" click={this.checkingDrain} checking={this.state.checkingDrain}/>
                <Inputnormal title="B" group="B-Drain" click={this.checkingDrain} checking={this.state.checkingDrain}/>
                <Inputnormal title="P" group="P-Drain" click={this.checkingDrain} checking={this.state.checkingDrain}/>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default withRouter(Tried);



// WEBPACK FOOTER //
// ./src/routes/Paitent/Tried.js